const brandColors = {
  cnx: {
    primary: {
      100: "#EEEBFF",
      200: "#CDC5FF",
      300: "#1900AF",
      400: "#13007D",
      500: "#0A0A32",
    },
    secondary: {
      100: "#FFEBEC",
      200: "#FFB0B5",
      300: "#FF646E",
      400: "#803237",
      500: "#4F1F22",
    },
    tertiary: {
      100: "#FCE1EB",
      200: "#FFBEE6",
      300: "#FF78AA",
      400: "#803C55",
      500: "#592A3B",
    },
  },
  pv: {
    primary: {
      100: "#DDD7EE",
      200: "#D596FF",
      300: "#A04FC9",
      400: "#7C23A8",
      500: "#4A245C",
    },
    secondary: {
      100: "#EEEBFF",
      200: "#CDC5FF",
      300: "#1900AF",
      400: "#13007D",
      500: "#0A0A32",
    },
    tertiary: {
      100: "#F2EFFF",
      200: "#C5B0FF",
      300: "#8053FF",
      400: "#6843CC",
      500: "#412A80",
    },
  },
};

const complementaryColors = {
  feedback: {
    success: {
      100: "#ECFFEB",
      200: "#CBFFC8",
      300: "#098500",
      400: "#076600",
      500: "#055200",
    },
    error: {
      100: "#FFE6E5",
      200: "#FFCAC9",
      300: "#BD0700",
      400: "#9E0500",
      500: "#3D0201",
    },
    warning: {
      100: "#FFFAE4",
      200: "#FFF5C5",
      300: "#BD9C00",
      400: "#695700",
      500: "#3D3300",
    },
    information: {
      100: "#E3FCFF",
      200: "#C3FFFF",
      300: "#00CDE6",
      400: "#005A66",
      500: "#00343B",
    },
  },
  neutral: {
    100: "#E6E6F0",
    200: "#9292A9",
    300: "#555567",
    400: "#42424F",
    500: "#27272E",
  },
  background: {
    gray: "#FAFAFC",
    white: "#FFFFFF",
  },
};

// EXPORT THEMES

export const cnx = {
  brand: { ...brandColors.cnx },
  ...complementaryColors,
};

export const pv = {
  brand: { ...brandColors.pv },
  ...complementaryColors,
};

export type ColorKeys = keyof typeof cnx;

export type Colors = typeof cnx;

export type Color = {
  100: string
  200: string
  300: string
  400: string
  500: string
};
